export default "__VITE_ASSET__DZKMoH46__"